import axios from '@/libs/api.request';

export const getRefundList = data => {
    return axios.request({
        url: 'web/saleManagement/refund/getPageRefundList',
        data: data,
        method: 'post'
    });
};

export const getRefundInfo = data => {
    return axios.request({
        url: 'api/saleManagement/refund/getRefundInfo',
        data: data,
        method: 'post'
    });
};

export const approveRefund = data => {
    return axios.request({
        url: 'api/saleManagement/refund/approveRefund',
        data: data,
        method: 'post'
    });
};

export const downloadApplyTable = data => {
    return axios.request({
        url: 'api/saleManagement/refund/downloadApplyTable',
        data: data,
        method: 'post'
    });
};
